import React from 'react';
import Header from '../header/header';
import Footer from '../footer/footer';
import PlanningStage from './planningstage';

const Stage = (props) => {
  return (
    <div>
            <Header />

    <div id="stage">

      <div className="container">

            <div className="stage-text">
              <h2>Stage</h2>
              <br></br>
              <br></br>
              <br></br>
              <p>Pendant les vacances scolaires, je vous propose des stages pour les enfants de 6 à 12 ans.
                <br></br>
Les horaires sont de 9 heures à 17 heures.
<br></br>
Il faut prévoir un pique-nique, un goûter et des affaires de sports.</p>
<br></br>
<br></br>
<h4>Exemple de programme sur la semaine :</h4>
<br></br>
<PlanningStage />
<br></br>
<br></br>
<h4>Les tarifs :</h4>
<br></br>
<ul>
<p>Pour les licenciés du club :</p>
  <p><li>20€ la journée</li></p>
  <p><li>90€ la semaine</li></p>
  <br></br>
  <p>Pour les non licenciés du club :</p>
<p><li>30€ la journée</li></p>
<p><li>100€ la semaine</li></p>
</ul>
<br></br>

<p>Plus d'informations et inscription sur <a href='https://www.ucathle.fr' target="blank">ucathle.fr</a></p>

 </div>
          </div>
        </div>

   
      <Footer />

    </div>
  );
};
export default Stage; 